// @ts-strict-ignore
import { getValue, getHrefValue } from '@u/product-schema'
import { getLinkAndText, getLink } from '@u/get-link-from-array'

export const getCtaText = (gridContentCell, query, data, phoneAddon) => {
  let ctaText = getValue(gridContentCell.primary.text)

  if (phoneAddon && getValue(phoneAddon.phoneNumber, data)) {
    return phoneAddon.ctaLabel
  }

  if (Array.isArray(gridContentCell.primary)) {
    const { ctaTextFromSchema } = getLinkAndText(gridContentCell.primary, query, data)

    ctaText = ctaTextFromSchema
  }

  return ctaText
}

export const clickableRowValue = (clickableRow, query, product, index) => {
  if (clickableRow) {
    let hrefValue = getHrefValue(clickableRow, product)

    if (Array.isArray(clickableRow)) {
      hrefValue = getLink(clickableRow, query, product)
    }

    if (hrefValue?.match(/^\//)) {
      // don't change relative urls
      return hrefValue
    }

    return hrefValue?.includes('?')
      ? `${hrefValue}&position=${index + 1}`
      : `${hrefValue}?position=${index + 1}`
  }
}
